import Link from "next/link";
import type { ReactNode } from "react";

export function AuthLayout({
  children,
  title,
  subtitle,
}: {
  children: ReactNode;
  title: string;
  subtitle?: string;
}) {
  return (
    <div className="bg-ink-50 flex min-h-[calc(100vh-4rem)] items-center justify-center px-4 py-12">
      <div className="w-full max-w-md">
        <div className="mb-8 text-center">
          <Link
            href="/"
            className="text-ink-900 text-2xl font-semibold tracking-tight"
          >
            Zeylora
          </Link>
          <h1 className="text-ink-900 mt-4 text-2xl font-semibold">{title}</h1>
          {subtitle && <p className="text-ink-500 mt-1 text-sm">{subtitle}</p>}
        </div>
        <div className="border-ink-100 rounded-lg border bg-white p-6 shadow-sm sm:p-8">
          {children}
        </div>
      </div>
    </div>
  );
}
